module.exports = __webpack_public_path__ + "img/codeGuide.0ad1192a.png";